import React from 'react';

import { dataLayerProvider, tracker } from '@femtasy/helpers';

import { isProduction } from 'helpers/env';

const StepPageViewWrapper = ({ trackingUrl, children }) => {
  React.useEffect(() => {
    tracker.pageView('', trackingUrl, undefined, !isProduction(), [
      dataLayerProvider,
    ]);
  }, [trackingUrl]);

  return <>{children}</>;
};

export default StepPageViewWrapper;
